import React, { useEffect, useRef, useState } from 'react'
import HeaderComponents from '../../components/HeaderComponents';
import "../../utils/Style/pages/ToDo.scss";
import ProgressBar from '../../components/ProgressBar/ProgressBar';
import "../../utils/Style/pages/DropOff.scss";
import useDropOffApi from '../../api/DropOffApi';
import { useDispatch, useSelector } from 'react-redux';
import { setActionPayload, setActionType, setShowQrWaitingImage } from '../../features/authorizationSlice';
import { ACTION_TYPES } from '../../app/actionTypes';
import { setIsPopup } from '../../features/responseSlice';
import { useOutletContext, useNavigate } from 'react-router-dom';
import { setTodoActiveButton } from '../../features/TodoSlice';
import useTodoApi from '../../api/TodoApi';
import { Spinner } from 'react-bootstrap';
import { resetDropOffResponse, setBillDropOffReferences } from '../../features/DropOffSlice';
import { clearWebSocketMessage } from '../../features/webSocketSlice';
import { v4 as uuidv4 } from 'uuid';


function DropOff() {
  const [currentStep, setCurrentStep] = useState(1);
  const [serialNumber, setSerialNumberID] = useState("");
  const [errors, setErrors] = useState({});
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [loading, setLoading] = useState(false);
  const [buttonText, setButtonText] = useState("Send Request");

  const [onOpenQrAfterGenerate] = useOutletContext();
  const { GetTransactionBySerialNumber } = useDropOffApi();
  const { SaveBillReference } = useTodoApi();
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const transactionBySerialNumber = useSelector((state) => state.dropOff.transactionBySerialNumber);
  const saveBillReferenceResponse = useSelector((state) => state.dropOff.saveBillReferenceDropOffResponse);
  const billDropOffReferences = useSelector((state) => state.dropOff.billDropOffReferences);
  const webSocketMessage = useSelector((state) => state.websocket.webSocketMessage);
  const webSocketClient = useSelector(state => state.websocket.webSocketClient)

  useEffect(() => {
    dispatch(resetDropOffResponse());
    dispatch(setBillDropOffReferences(""));

    return () => {
      dispatch(resetDropOffResponse());
    };
  }, []);


  // const fetchClipboardText = async () => {
  //   try {
  //     if (navigator.clipboard && navigator.clipboard.readText) {
  //       let text = await navigator.clipboard.readText();
  //       console.log("Fetched clipboard text: ", text);

  //       if (text.includes('BillReferenceGenerated$$$$')) {
  //         const cleanedText = text.replace(/BillReferenceGenerated\${4}/g, '').trim();
  //         console.log("Cleaned clipboard text: ", cleanedText);

  //         if (cleanedText !== billDropOffReferences) {
  //           // Set the value directly without altering spaces
  //           dispatch(setBillDropOffReferences(cleanedText));
  //           console.log("Updated Redux state with clipboard text");

  //           // Update the textarea directly
  //           if (textareaRef.current) {
  //             textareaRef.current.value = cleanedText;
  //             console.log("Updated textarea value with clipboard text");
  //           }
  //         }
  //       } else {
  //         console.log('Clipboard content does not match BillReferenceGenerated$$$$, skipping update');
  //       }
  //     } else {
  //       console.warn('Clipboard API not available, falling back to manual input');
  //     }
  //   } catch (err) {
  //     console.error('Failed to read clipboard contents: ', err); 
  //   }
  // };

  useEffect(() => {
    if (currentStep === 3 && inputRef.current) {
      inputRef.current.focus(); 
    }
  }, [currentStep]);

  const handleCurrentStep = () => {
    if (currentStep < 3) {
      setCurrentStep(currentStep + 1);
    }
  }

  const handleDismissed = () => {
    navigate("/todo");
    dispatch(setTodoActiveButton({ name: "OrderTable" }));
    dispatch(resetDropOffResponse());
  }

  const handleContinue = async () => {
    if (validateForm()) {
      setLoading(true);
      try {
        if (currentStep === 1) {
          await GetTransactionBySerialNumber(serialNumber);

          if (transactionBySerialNumber.flagCode === 1) {
            setErrors({ SerialNumber: transactionBySerialNumber.message });
            setLoading(false);
            return;
          }
        }
      } catch (error) {
        console.error("Error in setting serial number:", error);
        setErrors({ SerialNumber: "Error retrieving transaction. Please try again." });
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (transactionBySerialNumber?.flagCode === 1) {
      setErrors({ SerialNumber: transactionBySerialNumber.message });
    }

    if (transactionBySerialNumber?.flagCode === 0 && currentStep === 1) {
      handleCurrentStep();
    }
  }, [transactionBySerialNumber, currentStep]);

  useEffect(() => {
    if (saveBillReferenceResponse?.data?.payload?.flagCode === -1 && currentStep === 2) {
      setErrors({ BillReferences: saveBillReferenceResponse.data.payload.message });
    }
  }, [saveBillReferenceResponse, currentStep]);


  const handleContinueBillReference = async () => {
    if (validateForm()) {
      setLoading(true);
      try {
        if (currentStep === 2) {
          await SaveBillReference(transactionBySerialNumber.orderID, billDropOffReferences);
        }
      } catch (error) {
        console.error("Error saving bill reference:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSendMessage = () => {
    const guid = uuidv4();
    const channelID = 27; 
    const groupName = "CashPickup-Employee";  
    
    if (webSocketClient) {
      const message = {
        Guid: guid,
        ChannelID: channelID
      };
  
      webSocketClient.sendToGroup(groupName, JSON.stringify(message), "text")
        .then(() => {
          console.log(`Message sent to group ${groupName}: ${JSON.stringify(message)}`);
          setButtonText("Message Sent"); 
          
          setTimeout(() => {
            setButtonText("Send Request");
          }, 4000);
        })
        .catch((error) => {
          console.error("Failed to send message:", error);
        });
    } else {
      console.error("WebSocket is not connected");
    }
  };
  useEffect(() => {

    if (webSocketMessage) {
      // const formattedMessage = JSON.stringify(webSocketMessage, null, 2);
      // dispatch(setBillReferences(formattedMessage));

      const messageData = JSON.parse(webSocketMessage.message.data);

      if (messageData.Event === "CashPickUpDelivery-BillReference") {
        const payloadData = JSON.parse(messageData.Payload);
        const formattedMessage = {
          Currencies: payloadData.Currencies.map(currency => ({
            Currency: currency.Currency,
            Summary: currency.Summary,
            Bills: currency.Bills.map(bill => ({
              Amount: bill.Amount,
              SerialNumber: bill.SerialNumber
            }))
          }))
        };

        const formattedMessageString = JSON.stringify(formattedMessage, null, 2);


        dispatch(setBillDropOffReferences(formattedMessageString));

        dispatch(clearWebSocketMessage());
      }
    }
  }, [webSocketMessage, dispatch]);
  const formatBillReferencesAsHTML = (billReferences) => {
    if (!billReferences) return '';

    const parsedData = JSON.parse(billReferences);

    let formattedText = '';

    parsedData.Currencies.forEach((currency) => {
      formattedText += `<div class="currency" style="margin-bottom: 5px;">`;
      formattedText += `<p><strong>Currency:</strong> ${currency.Currency}</p>`;
      formattedText += `<p><strong>Count:</strong> ${currency.Summary.Count}</p>`;
      formattedText += `<p><strong>Total Amount:</strong> ${currency.Summary.TotalAmount}</p>`;
      formattedText += `<hr style="border: 2px solid #000; margin: 10px 0x;" />`; // Horizontal line
      formattedText += `<p><strong>Bills:</strong></p>`;

      formattedText += `<p>`;
      currency.Bills.forEach((bill, index) => {
        formattedText += `${bill.Amount} ${bill.SerialNumber}`;
        if (index < currency.Bills.length - 1) {
          formattedText += ` <br/>`;
        }
      });
      formattedText += `</p>`;

      formattedText += `</div>`;
    });

    return formattedText;
  };

  useEffect(() => {
    if (saveBillReferenceResponse?.data?.payload?.flagCode === 0 && currentStep === 2) {
      handleCurrentStep();
    }
  }, [saveBillReferenceResponse, currentStep]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (currentStep === 1) {
      if (!serialNumber.trim()) {
        newErrors.SerialNumber = "Serial Number is required";
        isValid = false;
      }
    }

    if (currentStep === 2) {
      if (!billDropOffReferences.trim()) {
        newErrors.BillReferences = "Bill References is required";
        isValid = false;
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  useEffect(() => {
    if (transactionBySerialNumber && transactionBySerialNumber?.currency === "USD") {
      setCurrencySymbol("$");
    } else {
      setCurrencySymbol("L.L");
    }
  }, [transactionBySerialNumber]);

  const handleOrderIDChange = (e) => {
    const value = e.target.value;
    setSerialNumberID(value);
  }

  const onScan = (data) => {
    dispatch(setIsPopup(false));

    const payload = {
      orderID: transactionBySerialNumber.orderID,
      qrData: data
    }

    dispatch(setActionType(ACTION_TYPES.SCAN_QR));
    dispatch(setActionPayload(payload));
    dispatch(setShowQrWaitingImage(false));
    onOpenQrAfterGenerate();
  };

  const handleInput = (e) => {
    if (e.key === 'Enter') {
      inputRef.current.style.position = 'absolute';
      onScan(e.target.value);
    }
  };

  return (
    <>
      <div className='DropOffPage'>
        <HeaderComponents title="Confirm Drop Off" />
        <div className='DropOffContainerPage'>
          <div className='orderBox'>
            <div className='boxHeader'>New Drop Off</div>
            <ProgressBar currentStep={currentStep} steps={["Envelope Serial Number", "Amount", "Scan QR"]} />
            {currentStep === 1 && (
              <div className='orderDetails'>
                <div className='orderId'>
                  <div className='boxLabel'>Envelope Serial Number</div>
                  <input
                    type='text'
                    className='orderID-input'
                    placeholder='- - - - - -'
                    value={serialNumber}
                    onChange={handleOrderIDChange}
                    disabled={loading}
                    maxLength={6}
                    pattern="[A-Za-z0-9]{0,6}"
                  />
                </div>
                {errors.SerialNumber && <div className="error-dropOff mt-1" style={{ marginLeft: "138px" }}>{errors.SerialNumber}</div>}
                <div className='buttons'>
                  <button className='dismissed-btn' onClick={handleDismissed}>Dismissed</button>
                  <button className='continue-btn' onClick={handleContinue} disabled={loading}>
                    {loading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      'Confirm & Continue'
                    )}
                  </button>
                </div>
              </div>
            )}

            {currentStep === 2 && (
              <div className='orderDetails'>
                <div className="send-request">
                  <button className="send-request-btn" onClick={handleSendMessage} disabled={buttonText === "Message Sent"}>
                  {buttonText} 
                </button>
                </div>
                <div className='orderAmount'>
                  <div className='boxLabel'>Deposited Amount</div>
                  <div className='amountNumber'>{currencySymbol}{transactionBySerialNumber?.amount}</div>
                </div>
                <div className='orderAmount'>
                  <div className='boxLabel'>Driver Name</div>
                  <div className='amountNumber'>{transactionBySerialNumber?.driverName}</div>
                </div>


                <div className="billReferences">
                  <div className="boxLabel">Bill References</div>
                  <div className="billHtmlView bordered-div" dangerouslySetInnerHTML={{ __html: formatBillReferencesAsHTML(billDropOffReferences) }}></div>
                  {errors.billDropOffReferences && (
                    <div className="error m-0">{errors.billDropOffReferences}</div>
                  )}
                </div>
                {errors.BillReferences && <div className="error-dropOff" style={{ marginTop: "-28px", marginLeft: "32px" }}>{errors.BillReferences}</div>}
                <div className='buttons'>
                  <button className='dismissed-btn' onClick={handleDismissed}>Dismissed</button>
                  <button
                    className='continue-btn'
                    onClick={handleContinueBillReference} 
                    disabled={loading}
                  >
                    {loading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Confirm & Continue"
                    )}
                  </button>
                </div>
              </div>
            )}

            {currentStep === 3 && (
              <div className='orderDetails'>
                <div className='successOrder'>
                  <img src='/Images/Scan-Suyool-QR-Code-500x500.gif' style={{ height: "400px" }} />
                  <div
                    style={{
                      position: 'absolute',
                      left: '-9999px',
                      border: '1px solid red'
                    }}
                  >
                    <input
                      ref={inputRef}
                      type="text"
                      onKeyDown={handleInput}
                      onBlur={() => {
                        if (inputRef.current) {
                          setTimeout(() => inputRef.current.focus(), 0);
                        }
                      }}
                    />
                  </div>
                  <div className='success-message'>
                    <div className='bold-text'>Scan to Complete Deposit</div>
                    Make sure to scan the QR
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default DropOff;
